<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>

            <v-tab :ripple="true"> پیش نمایش </v-tab>
            <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 10px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" :svg="svgMade" />
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
              </div>
            </v-tab-item>

            <v-tab-item>
              <component :is="cardTexts.designSettings?.theme" v-model="cardTexts" :orders.sync="cardTexts.orders" />
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
              <Tariffs :id_qr="info.id" :qrtype="'SocialMedia'" />
          </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله اول -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات شبکه های اجتماعی</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام شبکه اجتماعی"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام شبکه اجتماعی"
                  />
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <!-- مرحله دوم -->
            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>

                  <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>


              <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                  @save-required="AutoSave && qrUpdate(false)"

                  >

                  <template v-slot:content>
                  <theme-layout-selector v-model="cardTexts.designSettings" />
                  </template>
                </list-expansion>
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"

              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>

          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
               :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                :qr_id="info.qrId"
                @close="showDialog = false"
              />
            </v-card>
          </custom-popup>
        </v-col>
      </v-row>
    </template>
    <QrIntroModal v-if="$vuetify.breakpoint.mdAndUp"
        storageKey="socialmediaQrIntroSeen"
        title="کیوآر شبکه اجتماعی"
        :pro="false"
        icon="mdi-comment-account"
        iconColor="red darken-2"
        :description="introText"
      />
  </help-info-wrapper>
</template>

<script>
import QrIntroModal from "../../QrIntroModal.vue";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie.js";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import SocialMobile from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile.vue";
import socialMobile1_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile1_ok.vue";
import socialMobile2_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile2_ok.vue";
import socialMobile3_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile3_ok.vue";
import socialMobile4_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile4_ok.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import { Bus } from "@/main";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import ThemeLayoutSelector from "./ThemeLayoutSelector.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "indexSocial",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    DownloadFileWithApi,
    QrCodeMake,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
    Tariffs,
    ThemeLayoutSelector,
    socialMobile1_ok,
    socialMobile2_ok,
    socialMobile3_ok,
    socialMobile4_ok,
    QrIntroModal,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,

            introText: `
        <strong>کیوآر شبکه اجتماعی</strong> یک ابزار حرفه‌ای و جامع برای معرفی شما یا کسب‌وکارتان در فضای دیجیتال است. با این کیوآر می‌توانید تمامی راه‌های ارتباطی و لینک‌های مهم خود را در یک صفحه اختصاصی و زیبا تجمیع کنید.
        <br><br>
        <strong>امکانات این صفحه:</strong>
        <br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. مدیریت جامع لینک‌ها:</strong> افزودن انواع لینک‌ها شامل شبکه‌های اجتماعی (ایرانی و خارجی)، پیام‌رسان‌ها، سایت‌ها و اپلیکیشن‌ها.<br>
          <strong>۲. شخصی‌سازی کامل ظاهر:</strong> انتخاب قالب و چیدمان دلخواه (لیستی، شبکه‌ای و...)، آپلود لوگو، تصویر پس‌زمینه و بنرهای نمایشی.<br>
          <strong>۳. پروفایل اختصاصی:</strong> درج عنوان کسب‌وکار، متن "درباره ما"، آدرس سایت و ایجاد دکمه‌های ارتباطی با متن سفارشی.
        </span>
        <br>
        این کیوآر بهترین جایگزین برای کارت ویزیت‌های سنتی و کامل‌ترین ابزار برای لینکِ بایو (Bio) اینستاگرام شماست.
      `,
      helpData: [],
      serviceName: "Qrland",
      componentName: "indexSocial",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      createdId: null,
      createdDomain: null,
      dtUrl: null,
      domainId: null,
      showDialog: false,
      loading: false,
      errors: {},
      info: null,
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      cardTexts: {
          orders: [
              { name: 'banner' },
              { name: 'profile' },
              { name: 'about' },
              { name: 'socialMedia' },
            ],
        advanceSettings: {
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: false,
            forcedSubmission: "optional",
          },
          hasManifestIcons: true,
          manifest: {
            icon48: "https://cdn.terminalads.com/upload/67d49c914b6d1.webp",
            icon144: "https://cdn.terminalads.com/upload/67d49c918fa23.webp",
            screenshotWide: "",
            screenshot600: "",
          },
          hasAssistants: false,
          aiChatConfig: {
            assistant: {
            },
           },
        },
            designSettings: {
              theme: "socialMobile4_ok",
              layout: "SocialListGrouped"
            },
        visitName: "شبکه های اجتماعی",
        banner: {
          gallery: [
            {
              name: "بنر",
              images: [
                {
                  name: "بنر ۱",
                  title: "images1",
                  url: "",
                  description: "کیوآرلند مدرنترین روش تبلیغات با اقتصادی ترین هزینه ممکن!",
                  link: "",
                },
                {
                  name: "بنر ۲",
                  title: "images2",
                  url: "",
                  description: "با ترمینال تبلیغات، کسب‌وکار خود را متمایز کنید!",
                  link: "",
                },
              ],
            },
          ],
        },
        photo: {
          profile: "",
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
          headBackground: "",
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          grid: false,
          secondPosition: true,
        },
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                title: "",
                url: "https://www.aparat.com/video/video/embed/videohash/VdKgy/vt/frame",
                description:
                  "تو این ویدیو به بررسی گوشی اقتصادی جی پلاس Q20 پرداختیم که مشابه گوشی آیفون 13 است !\n" +
                  "یکی از مقرون به صرفه ترین گوشی ایرانی ، قطعا گوشی اقتصادی جی پلاس Q20 هست که ظاهر شبیه Iphone 13 داره !\n",
                link: "",
              },
            ],
          },
        ],
        buttonName: "راه های ارتباطی من",
        organizationName: "ترمینال تبلیغات",
        subtitle: "در کمتر از چند دقیقه سازمان خودرا به مخاطب معرفی کنید!",
        website: "",
        aboutUs:
          "ترمینال تبلیغات\n" +
          "\n" +
          "تنها سامانه جامع بررسی و مدیریت تبلیغات آنلاین\n" +
          "\n" +
          "سامانه ترمینال تبلیغات بزرگترین و مهمترین سرمایه خود را مشتریان و کاربران وفادار می داند.",
        PicSelector: {
          title: "",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          grid: true,
        },
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right , #1e3c72, #2a5298)",
            text: "#ffffff",
          },
          slider: false,
          grid: false,
        },
        socialMediaIcons: {
          sectionColor: {
            backGround: "linear-gradient(to right , #345998, #284273)",
            text: "#ffffff",
            icon:'#FA9797'
          },
          slider: false,
          grid: false,
        },
        socialMedia: {},
        customerClub: {
          configs: {
            patternId: 499,
            smsType: "pattern",
            isActive: true,
            message: {
              data1: {
                text: "name",
                state: "userInfo",
              },
              data2: {
                text: "lastName",
                state: "userInfo",
              },
            },
          },
          title: "عضویت در باشگاه مشتریان",
          description: "این یک باشگاه مشتریان عادی نیست!\nشمارتو ثبت کن",
        },
      },      
      qrSvgDataUrl: "",
    };
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
     this.cardTexts.banner.gallery[0].images[0].url = this.defaultroboatUrl;
    this.cardTexts.banner.gallery[0].images[1].url = this.defaultroboatUrl;
    this.cardTexts.photo.profile =
      this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";
    this.cardTexts.website = this.$coreqrApi;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  computed: {
        specialInfo() {
          return [
            {
              name: "bannerSelector",
              value: "",
              title: this.$t("edit_bpage_special_info_special.upload_image"),
              icon: "image",
              model: "banner",
            },
              {
          name: "customerClubSettings",
          title: this.$t("sms_club_membership"),
          icon: "cellphone-message",
          model: "customerClub",
        },
            {
              name: "baseInfo",
              value: "",
              title: this.$t("edit_bpage_special_info_special.information"),
              icon: "account-outline",
            },
            {
              name: "imageUploader",
              value: "",
              title: this.$t("edit_bpage_special_info_special.upload_logo"),
              icon: "image",
              model: "photo",
            },
            {
              name: "socialMediaIcons",
              value: "",
              title: this.$t("edit_bpage_special_info_special.add_social_media"),
              subtitle: "",
              icon: "instagram",
              model: "socialMedia",
            },
          ];
        },
    defaultroboatUrl() {
      return this.$cdnUrl + "/upload/64b1535578ce0.webp";
    },
    defaultProfileImage() {
      return (
        this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
      );
    },
    defaultWebsite() {
      return this.$coreqrApi || "https://qr.terminalads.com";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    
    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "SocialMedia",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.info = data.data;
          this.qrShow = 0;
          this.$toast.success("کیوآر شبکه اجتماعی شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "SocialMedia");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          if (final) {
            this.$toast.success("کیوآر شبکه اجتماعی شما باموفقیت ویرایش شد.");
            this.goto("qr/list");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving = false;

        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
